"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.defaultOrderByOptions = exports.FAILED = exports.FETCHED = exports.FETCHING = exports.STANDBY = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/congrid/files");
const _folderTreeReducer = require("../../modules/files/tree/reducers");
const folderTreeReducer = _folderTreeReducer.default('congrid', 'NO_INHERIT_SELECTION');
exports.STANDBY = 'STANDBY';
exports.FETCHING = 'FETCHING';
exports.FETCHED = 'FETCHED';
exports.FAILED = 'FAILED';
exports.defaultOrderByOptions = {
    orderBy: 'id',
    order: 'asc'
};
exports.initialState = {
    status: exports.STANDBY,
    items: [],
    removeStatus: exports.STANDBY,
    folderContent: folderTreeReducer.initialState
};
const statusLens = monocle.Lens.fromProp('status');
const itemsLens = monocle.Lens.fromProp('items');
const removeStatusLens = monocle.Lens.fromProp('removeStatus');
let methods = {};
exports.methods = methods;
// FETCH
methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set(exports.FETCHING)(state);
methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(itemsLens.set(action.payload), statusLens.set(exports.FETCHED))(state);
methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set(exports.FAILED)(state);
// REMOVE
methods[ActionTypes.REMOVE_REQUEST] = (state, action) => removeStatusLens.set(exports.FETCHING)(state);
methods[ActionTypes.REMOVE_SUCCESS] = (state, action) => removeStatusLens.set(exports.FETCHED)(state);
methods[ActionTypes.REMOVE_FAILED] = (state, action) => removeStatusLens.set(exports.FAILED)(state);
// CLEAR
methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, exports.initialState));
const folderContentLens = monocle.Lens.fromProp('folderContent');
const folderContentMethods = Object.keys(folderTreeReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => folderContentLens.set(folderTreeReducer.reducer(state.folderContent, action))(state);
    return prev;
}, {});
exports.methods = methods = Object.assign(methods, folderContentMethods);
//# sourceMappingURL=files.js.map